<template>
<div>
    <head-nav></head-nav>

    <div class="form-login">
        <img src="../../img/mission-logo.png" class="form-login-img" >
        <br>
        <br>
        <span style=" font-family: lemon_milkregular;padding-top:15px;padding-bottom:15px; text-transform:uppercase">
            Please login first.
        </span>
        <br>
        <br>
        <form class="login-form" @submit.prevent="login">
            <input type="text" name="username" placeholder="Email Address"  style="font-family:berleno; " v-model="loginUser.email" />
            <div class="password-container">
                <input name="password" placeholder="Password" type="password"  style="font-family:berleno; " v-model="loginUser.password" :type="isPasswordVisible ? 'text' : 'password'">
                <span @click="togglePasswordVisibility" class="eye-icon">
                        <i :class="isPasswordVisible ? 'icon-eye-hidden' : 'icon-eye'"></i>
                    </span>
            </div>
            <button class="btn btn-dark" name="submit" type="submit">login</button>
        </form>  
            <br>
            <router-link class="message" to="/lost-password" id="passreset" style="font-family:berleno">Forgot Password</router-link>
            <br>
            <br>
            <a class="message" href="/the-magazine" style="font-family:berleno">Back to website</a>
    </div>
     <info></info> 
</div>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapState
} from "vuex";
import headNav from '../../components/navBar'
import info from '../../components/info'
import firebase from '@/firebase'; // Importar Firebase
import { auth } from '@/firebase';
import Swal from 'sweetalert2';
export default {
    components: {
        headNav,
        info
    },
    data() {
        return {             

            isPasswordVisible: false,
        }
    },
    methods: {
        togglePasswordVisibility() {
            this.isPasswordVisible = !this.isPasswordVisible;
        },
        async login() {  
            try {
                 // Configurar la persistencia antes de iniciar sesión
                auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL) // O 'SESSION', 'NONE'
                    .then(() => {
                    // Una vez configurada la persistencia, iniciar sesión
                    return auth.signInWithEmailAndPassword(this.loginUser.email, this.loginUser.password);
                    })
                    .then(async (userCredential) => {
                        
                        const user = userCredential.user;
                        if (!user.emailVerified) {
                            await user.sendEmailVerification();
                            auth.signOut();
                             return  Swal.fire({
                            position: 'center',
                            icon: 'info',
                            title: 'Please confirm your email address before you log in.',
                            html: `Please confirm your email address before you log in. If email is not received, please check your spam folder or email us at <a href="mailto:info@missionmag.org">info@missionmag.org</a>.`,
                            showCancelButton: false, 
                            confirmButtonText: 'Ok',
                        })
                        }

                        // Obtener el token de ID
                        const idToken = await user.getIdToken();
                        localStorage.setItem('token',idToken),
                        localStorage.setItem('logged', true),               
                        this.$router.push("/home")
                    })
                    .catch((error) => {
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: 'Access Denied',
                            text: error.message,
                            showCancelButton: false,
                            confirmButtonText: 'Ok',
                        })
                    });              
            } catch (error) {
                swal({
                    title: "Access Denied",
                    icon: 'error',
                    text: error.message,
                    buttons: false,
                    timer: 1500,
                })
            }     
        },
    },
    computed: {
        ...mapState('inPlayer', [
            'loginUser',            
        ])
    },

}
</script>

<style>

.password-container {
  position: relative;
  display: flex;
  align-items: center;



  .eye-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 20px;
    user-select: none;
  }
}
.form-login {
    position: relative;
    z-index: 1;
    background: #FFFFFF;
    max-width: 500px;
    max-height: 500px;
    margin: 20px auto 40px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form-login-img{
	max-width:300px;
	 margin-left: -11px
}
.form-login input {
    font-family: 'berleno';
    outline: 0;
    background: #f2f2f2;
    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 15px;
    box-sizing: border-box;
    font-size: 14px;
}

.form-login button {
    font-family: 'lemon_milkregular';
    text-transform: uppercase;
    outline: 0;  
    width: 100%;
    border: 0;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    -webkit-transition: all 0.3 ease;
    transition: all 0.3 ease;
    cursor: pointer;
}


.form-login .message {
    font-family: 'lemon_milkregular';
    margin: 15px 0 0;
    color: #212529;
    font-size: 15px;
    text-decoration: none;
}
@media (max-width:426px){
	.form-login-img{
		max-width:250px;
	}
}

</style>
